var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 270.574,
  height: 230.849,
  viewBox: "0 0 270.574 230.849"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 270.574,
  height: 230.849,
  fill: "none"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M971.123,473.3c-.044,3.445-.2,7.3-.555,11.37L980.49,472.3l.07.194a30.944,30.944,0,0,0-3.569-7.913l.079.182Z",
  transform: "translate(-727.415 -344.913)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M971.285,458.248l5.759-8.272a16.3,16.3,0,0,0-5.9-5.6c-.118-.061-.236-.118-.354-.175C970.874,445.129,971.354,450.605,971.285,458.248Z",
  transform: "translate(-727.57 -330.461)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M972.094,564.447q.366-2.164.568-4.318L957.7,571.881l-.02-.1q-.338,1.272-.7,2.5l15.085-10.059Z",
  transform: "translate(-717.779 -412.648)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.328,516.014,978.719,503.6l.052.215a48.652,48.652,0,0,0-1.866-11.332L966.8,505.093Q966.272,510.807,965.328,516.014Z",
  transform: "translate(-723.7 -364.694)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.226,491.179l-17.913-17.8.078-.217a40.625,40.625,0,0,0-3.626,7.341l20.385,19.333C916.634,496.812,916.981,493.893,917.226,491.179Z",
  transform: "translate(-674.385 -350.994)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M913.162,520.939q.205-1.107.386-2.2l-20.46-19.4.076-.219q-.508,1.354-.953,2.8l.074-.22Z",
  transform: "translate(-671.866 -369.394)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M959.831,551.542l14.838-11.654.043.223a58.087,58.087,0,0,0,.175-7.83L961.315,544.86Q960.666,548.328,959.831,551.542Z",
  transform: "translate(-719.804 -392.906)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M886.169,553.644l16.778,19.45a69.889,69.889,0,0,0,2.948-7.838L885.7,546.365a56.206,56.206,0,0,0,.372,7.515Z",
  transform: "translate(-667.246 -402.89)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M944.2,441.583l.136-.071a11.024,11.024,0,0,0-10.647.838l11.02,13.286C944.786,447.368,944.212,441.665,944.2,441.583Z",
  transform: "translate(-701.274 -327.848)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M949.015,586.876a69.427,69.427,0,0,1-2.665,7.069l15.222-9.027.029.225a27.518,27.518,0,0,0,2.383-6.525q.3-1.337.53-2.678l-15.264,10.178C949.172,586.371,949.095,586.625,949.015,586.876Z",
  transform: "translate(-710.247 -423.856)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M926.931,460.985l-11.273-13.591.086-.208a23.428,23.428,0,0,0-7.125,7.381l17.768,17.656C926.734,468.2,926.888,464.389,926.931,460.985Z",
  transform: "translate(-683.499 -332.58)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M906.1,538.651a94.309,94.309,0,0,0,2.411-9.861L887.577,509.5q-.594,1.956-1.065,4.058a33.791,33.791,0,0,0-.739,6.107l20.308,19Z",
  transform: "translate(-667.303 -376.753)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1010.947,674.129c-2.231,2.625-4.814,5.5-7.68,8.4l15.533-3.2-.07.194a30.947,30.947,0,0,0,2.3-8.371l-.056.19Z",
  transform: "translate(-750.596 -491.355)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1039.732,641.88c-.052-.122-.106-.242-.161-.361-.527.774-3.65,5.3-8.578,11.14l9.712-2.7A16.3,16.3,0,0,0,1039.732,641.88Z",
  transform: "translate(-770.251 -470.347)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M947.017,754.365q-1.071.764-2.137,1.476l18.034,1.874-.119.2q1.662-1.433,3.191-2.963l-19.02-.492Z",
  transform: "translate(-709.205 -550.345)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M973.9,711.337l18.23-1.018-.1.2a48.655,48.655,0,0,0,5.791-9.917L982,703.861Q977.952,707.929,973.9,711.337Z",
  transform: "translate(-729.78 -512.231)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M953.638,740.6l18.862.488-.109.2a58.1,58.1,0,0,0,5.129-5.919L959.043,736.4Q956.331,738.654,953.638,740.6Z",
  transform: "translate(-715.413 -536.876)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M825.175,634.722c.125-.143.252-.288.383-.439a48.355,48.355,0,0,0,10.958-3.836l-.272-13.529q.2-.53.381-1.068l.29,14.4a69.889,69.889,0,0,0,7.27-4.157l-3.2-25.047.4-.238,3.194,25.015.017,0a94.319,94.319,0,0,0,8.146-6.057l-3.33-24.635q.193-.159.386-.321l3.33,24.636q.864-.722,1.7-1.448l-3.015-24.959q.192-.177.383-.356l3.017,24.979c2.3-2.018,4.43-4.045,6.35-5.979l-2.443-25.136.2-.118c-.688.223-1.384.475-2.086.752a35.607,35.607,0,0,0,3.335-5.146L845.2,591.151a53.422,53.422,0,0,1-3.33,6.205c-.273.289-.544.582-.812.883l.039.306q-.179.266-.36.528l-.052-.407c-.153.176-.3.356-.455.535a50.318,50.318,0,0,0,4.692-8.211l-16.655-19.308c.209,1.794.489,3.6.819,5.379a30.556,30.556,0,0,0-5.554-6.024l.131.149-3.015,9.959c1.023,3.29,2.066,7.009,2.986,10.985l5.534-14.628q.063.332.128.662l-5.52,14.59q1.269,5.6,1.98,10.84l6.923-12.4q.08.254.16.505l-7,12.536q.455,3.5.654,6.814l8.6-12.82.174.465-8.689,12.955-.051-.092q.072,1.314.1,2.595l9.816-12.43q.1.242.182.446l-9.986,12.645c0,.265.01.531.012.794a69.422,69.422,0,0,1-.35,7.546l.954-1.084q-.253.614-.493,1.21l-.542.617c-.043.374-.09.743-.14,1.111q-.277.716-.533,1.4.208-1.279.359-2.574L804.1,610.614c6.282,13.682,17.356,26.4,18.064,27.209q.714-1.542,1.289-3.155c.13-.02.26-.042.39-.063-.045.129-.089.259-.135.387l-.2.035.177.038q-.409,1.13-.873,2.207c.436-.44,1.09-1.121,1.882-2,5.009.974,18.448,2.894,29.59-1.739l-17.649-2.783A48.83,48.83,0,0,1,825.175,634.722Zm10.97-22.763.393-.447.013.635-.393.447Z",
  transform: "translate(-609.402 -420.382)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1038.8,626l.15.032a11.024,11.024,0,0,0-8.735-6.146l.013,17.262C1035.557,630.83,1038.752,626.071,1038.8,626Z",
  transform: "translate(-769.699 -455.013)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M924.722,761.12a69.444,69.444,0,0,1-6.561,3.744l17.481,2.757-.121.192a27.521,27.521,0,0,0,6-3.506q1.082-.84,2.116-1.725l-18.248-1.9C925.165,760.83,924.943,760.978,924.722,761.12Z",
  transform: "translate(-690.263 -554.826)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M996.925,645.451c2.831-2.875,5.383-5.714,7.587-8.309l-.014-17.658.2-.1a23.429,23.429,0,0,0-10.2,1.14Z",
  transform: "translate(-744.382 -454.534)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M851.514,561.965a16.3,16.3,0,0,0-7.347-3.5c-.131-.022-.261-.04-.391-.057.372.86,2.521,5.919,4.817,13.209Z",
  transform: "translate(-637.53 -411.424)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M812.887,616.91l-22.538-11.393.007-.231a40.621,40.621,0,0,0-1.18,8.1l25.363,12.086C814.065,622.45,813.493,619.567,812.887,616.91Z",
  transform: "translate(-598.823 -444.661)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M814.472,646.27l-25.456-12.13,0-.232q-.064,1.445-.042,2.953l0-.232,25.8,11.852Q814.639,647.365,814.472,646.27Z",
  transform: "translate(-598.679 -464.951)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M819.5,693.586l-25.043-11.725a56.2,56.2,0,0,0,2.676,7.032l.017-.252,21.968,13.312A69.881,69.881,0,0,0,819.5,693.586Z",
  transform: "translate(-602.568 -498.946)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M819.073,558.243l.108-.109a11.024,11.024,0,0,0-9.867,4.088l14.587,9.229C821.415,563.565,819.106,558.318,819.073,558.243Z",
  transform: "translate(-613.099 -411.177)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M812.815,582.561l-14.922-9.441.018-.224a23.43,23.43,0,0,0-4.495,9.222l22.355,11.3C814.858,589.487,813.826,585.812,812.815,582.561Z",
  transform: "translate(-601.829 -421.698)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M815.626,666.87a94.309,94.309,0,0,0-.755-10.123L789,644.866q.039,2.044.242,4.189a33.8,33.8,0,0,0,1.185,6.036l25.186,11.792Z",
  transform: "translate(-598.7 -472.72)",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.492,288.053l-75.131-9.47c-3.405-28.325,1.739-55.978,10.523-83.478l75.131,9.47A154.507,154.507,0,0,0,622.492,288.053Z",
  transform: "translate(-426.645 -153.876)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 46.276,
  height: 4.972,
  transform: "matrix(0.992, 0.125, -0.125, 0.992, 141.736, 51.225)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "matrix(0.992, 0.125, -0.125, 0.992, 131.123, 62.029)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "matrix(0.992, 0.125, -0.125, 0.992, 130.118, 69.998)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "matrix(0.992, 0.125, -0.125, 0.992, 129.114, 77.966)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "matrix(0.992, 0.125, -0.125, 0.992, 128.109, 85.935)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "matrix(0.992, 0.125, -0.125, 0.992, 127.105, 93.903)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "matrix(0.992, 0.125, -0.125, 0.992, 126.101, 101.871)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "matrix(0.992, 0.125, -0.125, 0.992, 125.096, 109.84)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M514.636,159.737l-70.289-28.173c3.873-28.265,15.847-53.716,31.3-78.1l70.289,28.173A154.507,154.507,0,0,0,514.636,159.737Z",
  transform: "translate(-354.368 -53.465)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("rect", {
  width: 46.276,
  height: 4.972,
  transform: "translate(128.909 12.327) rotate(21.841)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(115.907 20.094) rotate(21.841)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(112.919 27.549) rotate(21.841)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(109.931 35.004) rotate(21.841)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(106.943 42.459) rotate(21.841)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(103.955 49.914) rotate(21.841)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(100.967 57.369) rotate(21.841)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(97.979 64.824) rotate(21.841)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M430.491,236.952H354.765c-6.921-27.677-5.275-55.756,0-84.139h75.725A154.506,154.506,0,0,0,430.491,236.952Z",
  transform: "translate(-287.605 -123.894)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 46.276,
  height: 4.972,
  transform: "translate(78.825 37.523)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(69.646 49.571)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(69.646 57.602)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(69.646 65.634)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(69.646 73.665)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(69.646 81.696)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(69.646 89.728)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.722,
  height: 2.486,
  transform: "translate(69.646 97.759)",
  fill: "#ff005e",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M339.38,331.13l-26.088-20.282a2.978,2.978,0,0,0-2.582-1.494H296.63a2.978,2.978,0,0,0-2.978,2.978V436.608a9.66,9.66,0,0,0,9.66,9.66h144.54a9.66,9.66,0,0,0,9.66-9.66v-96.7a8.78,8.78,0,0,0-8.78-8.78Z",
  transform: "translate(-247.537 -234.87)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("rect", {
  width: 26.218,
  height: 9.176,
  transform: "translate(178.841 125.081)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.228,770.349s119.908-68.575,264.7,0",
  transform: "translate(-135.228 -540.07)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.379,301.3s1.287,6.821.386,7.336a15.647,15.647,0,0,0-2.059,1.544l2.316,3.217,5.534,1.158,5.276-4.89v-4.89s-1.544-2.445-1.287-3.99S219.379,301.3,219.379,301.3Z",
  transform: "translate(-193.698 -228.386)",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.379,301.3s1.287,6.821.386,7.336a15.647,15.647,0,0,0-2.059,1.544l2.316,3.217,5.534,1.158,5.276-4.89v-4.89s-1.544-2.445-1.287-3.99S219.379,301.3,219.379,301.3Z",
  transform: "translate(-193.698 -228.386)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.876,344.183l-.772.386s-1.673.643-2.445,6.177-2.574,18.789-2.059,19.175.257,2.96.257,2.96l3.861-20.2Z",
  transform: "translate(-163.074 -259.56)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.8,233.323c-.118.246-.159.533-.269.783-.5,1.137-1.929.882-2.959,1.312a2.859,2.859,0,0,0-1.591,2.444c-.029.459.038.921,0,1.378-.076.845-.512,1.589-.667,2.419-.377,2.016.5,5.2,1.494,4.112.313-.343.7-.571,1.043-.879a18.422,18.422,0,0,0,2.038-3.078,1.076,1.076,0,0,1,.362-.359c.521-.259.985.434,1.4.888a2.187,2.187,0,0,0,3.28-.063,1.925,1.925,0,0,1,.462-.472.986.986,0,0,1,.642-.063,4.217,4.217,0,0,1,2.571,1.531,7.776,7.776,0,0,0,1.044,1.242,1.031,1.031,0,0,0,1.385.046,3.285,3.285,0,0,1,1.028,2.671c0,1.021-.207,2.036-.156,3.055a2.856,2.856,0,0,0,1.264,2.494,3.631,3.631,0,0,1,1.345-2.352,9.24,9.24,0,0,0,1.694-1.153c.937-1.076.64-2.866.676-4.4.044-1.893.7-3.7.816-5.593a3.558,3.558,0,0,0-1.936-3.916l-4.417-2.834a1.885,1.885,0,0,0-.655-.311c-.65-.117-1.212.493-1.829.762a3.7,3.7,0,0,1-1.605.195c-1.715-.046-2.2.287-3.35-.831a.812.812,0,0,0-.7-.232C212.516,232.227,211.177,232.536,210.8,233.323Z",
  transform: "translate(-184.847 -180.109)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.66,716.92l2.7,5.92-5.276,1.8-2.7-1.416.644-6.306Z",
  transform: "translate(-56.277 -508.237)",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.1,783.087s-4.247-2.574-5.019-1.673-6.949,7.464-6.949,7.464-9.523,5.148-2.188,5.92,19.3-4.5,19.3-4.5.643-6.949.129-7.078-2.7,1.158-3.732.772a4.614,4.614,0,0,1-1.544-.9Z",
  transform: "translate(-157.162 -569.385)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.46,734.509v5.276l-6.949-1.544,1.544-5.405Z",
  transform: "translate(-69.127 -519.52)",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.254,797.787s7.078-1.158,7.722,2.316,2.316,8.622.643,9.909-10.3,2.96-10.424.772a30.749,30.749,0,0,1,.9-6.435s.643-3.346.257-4.247S227.254,797.787,227.254,797.787Z",
  transform: "translate(-198.999 -580.997)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.608,499.633s-5.81,36.839-1.048,54.856,8.108,28.7,8.108,28.7,8.236-2.316,8.236-3.861-3.217-24.452-3.989-26.639-2.059-2.96-.9-4.762,3.089-13.384,3.089-13.384,4.247,19.175,4.5,19.69-2.7,29.985-2.7,29.985,8.5,6.165,9.009,1.544c.129-1.158,5.791-42.211,5.791-42.726s2.316-39.895-1.416-41.825S176.608,499.633,176.608,499.633Z",
  transform: "translate(-162.491 -369.744)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.751,
  cy: 8.751,
  r: 8.751,
  transform: "translate(21.949 57.983)",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.707,321.319v-.9l-2.574-4.247s-2.574.257-2.96,1.416-4.762,10.424-4.762,10.424l-4.633,41.568s12.741,3.089,14.671.9,9.266-49.8,9.266-49.8l1.03-5.791s-1.768-2.574-2.171-2.188-7.1,7.85-7.1,7.85l-.129,1.158Z",
  transform: "translate(-168.938 -237.211)",
  fill: "#ff005e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.686,321.57s-2.381-.579-3.153.837-.772,1.93-1.544,2.445-5.276,2.831-5.534,3.732-5.791,29.342-5.791,29.342-2.7,8.494-1.416,14.285.386,6.949,3.089,7.464,3.089.515,3.089-.257,3.475-26.9,5.92-28.7,1.8-21.492,1.8-21.492,3.475-4.247,3.475-4.89S182.2,321.522,181.686,321.57Z",
  transform: "translate(-155.555 -243.446)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M224.527,323.243c.359.06,5.276-6.306,5.662-6.049s2.316,3.6,2.574,3.6,11.2,2.7,12.1,7.722-6.306,20.977-6.306,20.977-3.089,9.137-2.445,13.127a26.876,26.876,0,0,1-.257,9.137c-.257,1.03-1.158,2.188-.9,2.7s-5.662-.643-8.108.772-13.384,2.445-12.741.9,1.03-7.593,2.831-14.028,6.435-21.62,5.662-22.65S223.755,323.115,224.527,323.243Z",
  transform: "translate(-191.125 -240.422)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.7,350.814l1.673,1.544s1.93,3.346,1.673,4.89,5.405,24.838,3.089,25.61-7.85,4.633-8.494,5.663a11.425,11.425,0,0,1-3.217,3.346c-1.03.515-2.059,1.416-2.7.9s-2.059-11.068-1.03-11.454,2.059-1.544,3.089-1.544a1.846,1.846,0,0,0,1.673-1.93c0-.9-.772-6.306-.772-6.306l-1.673-12.741Z",
  transform: "translate(-239.512 -264.261)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.677,238.443c-.1.186-.141.4-.238.592-.443.859-1.706.667-2.617.992a2.18,2.18,0,0,0-1.407,1.848c-.026.347.034.7,0,1.042a17.626,17.626,0,0,1-.59,1.828c-.333,1.524.444,3.931,1.321,3.108.277-.259.623-.431.922-.665a13.972,13.972,0,0,0,1.8-2.327.9.9,0,0,1,.32-.271c.461-.2.871.328,1.235.671a2.158,2.158,0,0,0,2.9-.047,1.6,1.6,0,0,1,.409-.357,1.008,1.008,0,0,1,.568-.048,3.891,3.891,0,0,1,2.274,1.157,6.219,6.219,0,0,0,.923.939,1.029,1.029,0,0,0,1.224.035,2.308,2.308,0,0,1,.909,2.019c0,.772-.183,1.539-.138,2.309a2.088,2.088,0,0,0,1.117,1.885,2.69,2.69,0,0,1,1.189-1.778,8.358,8.358,0,0,0,1.5-.872c.828-.813.566-2.166.6-3.327.039-1.431.619-2.8.722-4.228a2.964,2.964,0,0,0-.474-2.044,3.82,3.82,0,0,0-1.237-.916L227,237.846a1.8,1.8,0,0,0-.579-.235c-.575-.088-1.072.373-1.617.576a3.8,3.8,0,0,1-1.419.147c-1.516-.035-1.943.217-2.962-.628a.8.8,0,0,0-.616-.176C219.195,237.614,218.01,237.848,217.677,238.443Z",
  transform: "translate(-190.18 -183.947)",
  fill: "#2f2e41"
})))));
export default __webpack_public_path__ + "static/media/illustration-verify-email.35772633.svg";
export { SvgComponent as ReactComponent };